<template>
  <v-container fluid grid-list-xl fill-height>
    <v-layout justify-center align-center>
      <v-flex xs12 sm8 md4>
        <material-card color="primary" title="Services - Reset Password" text="Choose a new PASSWORD">
          <div v-if="loadingCheck">
          Loading...
          </div>
          <v-form ref="form" v-model="validForm" v-if="hasParameters && !loadingCheck">
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field id="input_username" v-model="resetForm.email" prepend-icon="mdi-account" name="email"
                    label="Username or Email" type="text" disabled :rules="[validators.email()]"></v-text-field>
                </v-flex>

                <v-flex xs12 md12>
                  <!-- //issue 212 -->
                  <!-- tolto validators.password, -->
                  <v-text-field autocomplete="false" v-model="resetForm.newpass" prepend-icon="mdi-lock" :append-icon="passwordType1 == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                      " @click:append="showPwd1" name="new_password" label="New Password" id="input_new_password" :type="passwordType1"
                      required :rules="[
                        v => validators.strong_password(v)
                      ]">
                    </v-text-field>
                  <!-- //issue 212 -->
                </v-flex>

                <v-flex xs12 md12>
                  <v-text-field autocomplete="new-password" v-model="resetForm.confirmpass" prepend-icon="mdi-lock"
                    :append-icon="passwordType2 == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                      " @click:append="showPwd2" name="confirm_password" label="Confirm Password" id="input_confirm_password"
                    :type="passwordType2" required :rules="[v => validators.confirm_password(v, resetForm.newpass)]">
                  </v-text-field>
                </v-flex>

                <v-flex xs6 text-left>
                  <br>
                  <a @click="login">Back to Login</a>
                </v-flex>

                <v-flex xs6 text-right>
                  <v-btn id="button_confirm" color="orange" class="mx-0 font-weight-light" @click="confirm_reset" :loading='loading'
                    :disabled="!validForm || loading">Confirm</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import validators from "@/utils/validators"
import { confirmResetPass, checkRestorePassToken } from '@/api/user'

export default {
  props: {
    query: { // Definisci i props
      type: Object,
      required: true
    }
  },
  data: () => ({
    resetForm: {},
    loading: false,
    loadingCheck: true,
    validForm: true,
    passwordType1: 'password',
    passwordType2: 'password',
    validators
  }),
  mounted() {
    this.resetForm.restore_pass_token = this.query.restore_pass_token
    this.resetForm.email = this.query.email;
    checkRestorePassToken(this.resetForm.restore_pass_token, this.resetForm.email)
    .then( () => {
      this.loadingCheck = false
    }).catch( () => {
      this.$root.$emit("openSnackbar", {
        message: "Restore password link is not valid.",
        color: "error"
      })
    })
  },
  computed: {
    hasParameters() {
      return this.query.restore_pass_token && this.query.email
    },
  },
  methods: {
    async confirm_reset() {
      this.loading = true
      try {
        await confirmResetPass(this.resetForm)
        this.$root.$emit("openSnackbar", {
          message: "The new password has been stored correctly!",
          color: "success"
        })

        this.$router.push({ path: "/login" })
      } catch (e) {
        this.$root.$emit("openSnackbar", {
          message: e.response.data.message,
          color: "warning"
        })
      }
      this.loading = false
    },
    showPwd1() {
      this.passwordType1 =
        this.passwordType1 === 'password' ? 'text' : 'password'
    },
    showPwd2() {
      this.passwordType2 =
        this.passwordType2 === 'password' ? 'text' : 'password'
    },
    login() {
      this.$router.push({ path: '/login' })
    },

  },

};
</script>
